const STORE_POLICIES = {
  shipping: `
    <h5>🚚 Shipping & Delivery</h5>
    <ul>
      <li><strong>Standard Shipping:</strong> Free on orders over $59 · $4.99 on orders under $59 · 2–6 business days</li>
      <li><strong>Fast Shipping:</strong> $15.99 flat rate · 2–4 business days</li>
      <li>All orders ship in <strong>plain, unbranded packaging</strong> — nothing reveals contents</li>
      <li>Billing statement shows <strong>HCCO Retail Ltd</strong></li>
      <li>Orders placed Mon–Thu ship next business day · Weekend orders ship Monday</li>
    </ul>
    <p class="note">⚠️ Please verify current rates at checkout. <a href="https://hotcherry.com/pages/shipping" target="_blank">Full shipping details →</a></p>
  `,
  returns: `
    <h5>↩️ Return Policy</h5>
    <ul>
      <li>Returns accepted on <strong>unopened items only</strong> (shipping seal intact) within <strong>30 days of delivery</strong></li>
      <li>For a refund, you must <strong>refuse delivery</strong> at the door — once opened, the order is final</li>
      <li><strong>Defective items</strong> within 30 days: contact <a href="mailto:care@hotcherry.com">care@hotcherry.com</a> with photos/video</li>
      <li>Orders are processed within ~30 minutes — cancellations must be immediate</li>
      <li>Returned packages due to wrong address are refunded minus shipping costs</li>
    </ul>
    <p class="note">⚠️ For hygiene reasons, opened packages cannot be returned under any circumstances. <a href="https://hotcherry.com/pages/return-policy" target="_blank">Full return policy →</a></p>
  `,
  priceMatch: `
    <h5>💰 Price Match Guarantee</h5>
    <ul>
      <li>Found it cheaper elsewhere? HotCherry will <strong>match the price</strong> on identical products</li>
      <li>If the price drops within <strong>7 days</strong> of purchase, we'll refund the difference</li>
      <li>Contact <a href="mailto:care@hotcherry.com">care@hotcherry.com</a> or call <a href="tel:1-888-467-0077">1-888-467-0077</a></li>
    </ul>
    <p class="note">⚠️ Please verify eligibility with our team. <a href="https://hotcherry.com/pages/customer-care" target="_blank">Contact customer care →</a></p>
  `
};

// Escape HTML special characters to prevent markup/script injection
// when rendering user or AI text via innerHTML.
function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function getLearningData() {
  try { return JSON.parse(localStorage.getItem('molly_learning') || '{"sessions":[],"topQuestions":{},"feedback":{}}'); }
  catch { return { sessions:[], topQuestions:{}, feedback:{} }; }
}
function saveLearningData(d) { try { localStorage.setItem('molly_learning', JSON.stringify(d)); } catch {} }
function recordFeedback(id, pos) { const d=getLearningData(); d.feedback[id]=pos; saveLearningData(d); }
function recordSession(s) { const d=getLearningData(); d.sessions.push({ts:Date.now(),summary:s}); if(d.sessions.length>50) d.sessions=d.sessions.slice(-50); saveLearningData(d); }
function trackQuestion(t) { const d=getLearningData(); d.topQuestions[t]=(d.topQuestions[t]||0)+1; saveLearningData(d); }

function saveSession() {
  try { sessionStorage.setItem('molly_session', JSON.stringify({history, liveProducts})); } catch {}
}
function loadSession() {
  try {
    var s = JSON.parse(sessionStorage.getItem('molly_session') || 'null');
    if (s && s.history && s.history.length >= 2) return s;
  } catch {}
  return null;
}

let chatOpen = false, msgId = 0, started = false;
let session = loadSession();
let history = session ? session.history : [];
let liveProducts = session ? (session.liveProducts || []) : [];

const WORKER = 'https://molly-hotcherry.care-3ae.workers.dev';
const sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();

function sendAnalytics(data) {
  fetch(WORKER+'/analytics', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data)}).catch(function(){});
}

// Move panel to document.body to escape Eurus theme transforms (fixes iOS position:fixed)
window.addEventListener('load', function() {
  var panel = document.getElementById('chat-panel');
  if (panel && panel.parentNode !== document.body) {
    document.body.appendChild(panel);
  }
});

function toggleChat() {
  chatOpen = !chatOpen;
  document.getElementById('chat-panel').classList.toggle('open', chatOpen);
  var bubble = document.getElementById('chat-bubble');
  if (chatOpen) {
    bubble.classList.add('hidden');
    if (window.innerWidth <= 600) document.body.style.overflow = 'hidden';
    if (!started) {
      started = true;
      if (history.length >= 2) {
        restoreMessages();
      } else {
        history = [];
        liveProducts = [];
        startConversation();
      }
    }
    setTimeout(function(){ document.getElementById('chat-input').focus(); }, 350);
  } else {
    bubble.classList.remove('hidden');
    document.body.style.overflow = '';
  }
}

function restoreMessages() {
  var wrap = document.getElementById('chat-messages');
  wrap.innerHTML = '';
  for (var i = 0; i < history.length; i++) {
    var msg = history[i];
    if (msg.role === 'user') {
      if (msg.content === 'Hi' || msg.content.indexOf('[SYSTEM:') === 0) continue;
      addMessage('user', msg.content);
    } else if (msg.role === 'assistant') {
      var content = msg.content || '';
      if (content.indexOf('[SYSTEM:') === 0) continue;
      var cleaned = content
        .replace(/FETCH:\{[\s\S]*?\}(?=\s|$)/g, '')
        .replace(/ANALYTICS:\{[\s\S]*?\}/g, '')
        .trim();
      var ri = cleaned.indexOf('RECOMMEND:');
      if (ri > -1) {
        var before = cleaned.slice(0, ri).trim();
        var afterRec = cleaned.slice(ri + 10);
        var depth = 0, endIdx = -1;
        for (var j = 0; j < afterRec.length; j++) {
          if (afterRec[j] === '{') depth++;
          else if (afterRec[j] === '}') { depth--; if (depth === 0) { endIdx = j; break; } }
        }
        var after = endIdx > -1 ? afterRec.slice(endIdx + 1).trim() : '';
        if (before) addMessage('bot', before);
        if (after) addMessage('bot', after);
      } else {
        if (cleaned) addMessage('bot', cleaned);
      }
    }
  }
  scrollToBottom();
}

var _blockScroll = false;
function scrollToBottom() {
  if (_blockScroll) return;
  var e = document.getElementById('chat-messages');
  e.scrollTop = e.scrollHeight;
}

function addMessage(role, content, productData) {
  var wrap = document.getElementById('chat-messages');
  var mid = 'msg_' + (++msgId);

  if (role === 'typing') {
    var d = document.createElement('div');
    d.className = 'msg bot'; d.id = 'typing-indicator';
    d.innerHTML = '<div class="msg-bubble"><div class="typing"><span></span><span></span><span></span></div></div>';
    wrap.appendChild(d); scrollToBottom(); return;
  }

  if (role === 'policy') {
    var d = document.createElement('div');
    d.className = 'msg bot';
    d.innerHTML = '<div class="info-card">' + content + '</div><div class="feedback-row"><button class="btn-feedback" onclick="handleFeedback(this,\'' + mid + '\',true)">👍 Helpful</button><button class="btn-feedback" onclick="handleFeedback(this,\'' + mid + '\',false)">👎 Not helpful</button></div>';
    wrap.appendChild(d); scrollToBottom(); return;
  }

  if (role === 'products') {
    productData.forEach(function(item) {
      var product = item.product, reason = item.reason;
      var d = document.createElement('div'); d.className = 'msg bot';
      var imgHtml = product.image
        ? '<img src="' + product.image + '" alt="product" style="width:100%;height:100%;object-fit:contain;border-radius:12px;background:#fff;">'
        : (product.emoji || '🛍️');
      var rawTags = product.rawTags || product.tags || [];
      var discountBadge = rawTags.includes('discountonmap') ? '<span class="product-badge badge-discount">&#x1F3F7;&#xFE0F; Extra 15% off</span>' : '';
      var whyHtml = reason ? '<div class="why-box"><strong>✦ Why Molly picked this for you</strong><p>' + escapeHtml(reason) + '</p></div>' : '';
      d.innerHTML = '<div class="product-card"><div class="product-img">' + imgHtml + '</div><div class="product-card-body"><h4>' + product.name + '</h4><div class="product-meta"><span class="product-price">$' + product.price.toFixed(2) + '</span><span class="product-badge ' + (product.inStock ? 'badge-green' : 'badge-red') + '">' + (product.inStock ? '● In Stock' : '● Out of Stock') + '</span>' + discountBadge + '</div>' + whyHtml + '<button class="btn-buy' + (product.inStock ? '' : ' oos') + '" ' + (product.inStock ? '' : 'disabled') + ' onclick="window.open(\'' + product.url + '\',\'_blank\')"> ' + (product.inStock ? 'View Product →' : 'Notify Me When Back') + '</button></div></div>';
      wrap.appendChild(d); // no scrollToBottom here
    });
    var fb = document.createElement('div'); fb.className = 'msg bot';
    fb.innerHTML = '<div class="feedback-row"><span style="font-size:0.72rem;color:#c9a4ba">Was this helpful?</span><button class="btn-feedback" onclick="handleFeedback(this,\'' + mid + '_r\',true)">👍 Yes!</button><button class="btn-feedback" onclick="handleFeedback(this,\'' + mid + '_r\',false)">👎 Not quite</button></div>';
    wrap.appendChild(fb);
    _blockScroll = true;
    setTimeout(function() {
      var allMsgs = wrap.querySelectorAll('.msg');
      var cards = wrap.querySelectorAll('.msg.bot .product-card');
      if (cards.length >= productData.length) {
        var firstCard = cards[cards.length - productData.length];
        var firstMsg = firstCard ? firstCard.closest('.msg') : null;
        if (firstMsg) {
          var target = firstMsg;
          for (var mi = 1; mi < allMsgs.length; mi++) {
            if (allMsgs[mi] === firstMsg) { target = allMsgs[mi - 1]; break; }
          }
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      // Unblock after scroll animation completes (smooth scroll ~1s)
      setTimeout(function() { _blockScroll = false; }, 1200);
    }, 50);
    return;
  }

  var d = document.createElement('div');
  d.className = 'msg ' + role;
  var chips = [];
  var text = content.replace(/CHIPS:\[([^\]]+)\]/g, function(_, raw) {
    try { chips = JSON.parse('[' + raw + ']'); }
    catch(e) { chips = (raw.match(/"([^"]+)"/g) || []).map(function(s) { return s.slice(1,-1); }); }
    chips = chips.filter(function(c) { return c && c.length > 1; });
    return '';
  }).trim();
  text = escapeHtml(text);
  if (role === 'bot') {
    text = text.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" style="color:#A41E61;text-decoration:underline;">$1</a>');
  }
  d.innerHTML = '<div class="msg-bubble">' + text + '</div>';
  if (chips.length) {
    var cw = document.createElement('div'); cw.className = 'chips';
    chips.forEach(function(c) {
      var b = document.createElement('button'); b.className = 'chip'; b.textContent = c;
      b.onclick = function() { disableChips(); sendUserMessage(c); };
      cw.appendChild(b);
    });
    d.appendChild(cw);
  }
  if (role === 'bot') {
    var row = document.createElement('div'); row.className = 'feedback-row';
    row.innerHTML = '<button class="btn-restart" onclick="restartChat()">↺ Start over</button>';
    d.appendChild(row);
  }
  wrap.appendChild(d); scrollToBottom();
}

function handleFeedback(btn, id, pos) {
  recordFeedback(id, pos);
  btn.closest('.feedback-row').querySelectorAll('.btn-feedback').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  btn.textContent = pos ? '👍 Thanks!' : '👎 Noted';
}

function disableChips() { document.querySelectorAll('.chip').forEach(function(c) { c.disabled = true; }); }
function removeTyping() { var e = document.getElementById('typing-indicator'); if (e) e.remove(); }

async function startConversation() {
  addMessage('typing');
  var r = await callClaudeGreeting();
  removeTyping();
  if (r) processReply(r);
}

async function sendUserMessage(text) {
  var input = document.getElementById('chat-input');
  var msg = text || input.value.trim();
  if (!msg) return;
  if (input) input.value = '';
  disableChips();
  var low = msg.toLowerCase();
  if (low.includes('ship')) trackQuestion('shipping');
  if (low.includes('return') || low.includes('refund')) trackQuestion('returns');
  if (low.includes('price') || low.includes('cheap')) trackQuestion('price_match');
  if (low.includes('beginner') || low.includes('first time')) trackQuestion('beginner');
  if (low.includes('couple')) trackQuestion('couples');
  addMessage('user', msg);
  history.push({role:'user', content:msg});
  saveSession();
  addMessage('typing');
  var r = await callClaude();
  removeTyping();
  if (r) processReply(r);
}

function processReply(reply) {
  if (!reply) return;

  var pol = reply.match(/POLICYTYPE:(shipping|returns|priceMatch)/);
  if (pol) {
    var txt = reply.replace(/POLICYTYPE:\S+/, '').trim();
    if (txt) addMessage('bot', txt);
    addMessage('policy', STORE_POLICIES[pol[1]]);
    history.push({role:'assistant', content:reply}); saveSession(); return;
  }

  var am = reply.match(/ANALYTICS:(\{[\s\S]*?\})/);
  if (am) {
    try { var ad = JSON.parse(am[1]); ad.sessionId = sessionId; ad.messageCount = history.length; sendAnalytics(ad); } catch(e) {}
    reply = reply.replace(/ANALYTICS:\{[\s\S]*?\}/, '').trim();
  }

  var fm = reply.match(/FETCH:(\{[\s\S]*?\})/);
  if (fm) {
    var fp = null;
    try { fp = JSON.parse(fm[1]); } catch(e) {}
    if (fp && fp.collections) {
      var pre = reply.replace(/FETCH:[\s\S]+/, '').trim();
      if (pre) addMessage('bot', pre);
      addMessage('typing');
      fetchCollectionProducts(fp).then(function(fetched) {
        removeTyping();
        liveProducts = fetched.map(function(p, i) { return Object.assign({}, p, {id: i+1}); });
        history.push({role:'assistant', content:reply});
        history.push({role:'user', content:'[SYSTEM: ' + fetched.length + ' products loaded with ids 1-' + fetched.length + '. Recommend best 1-2 using RECOMMEND:{"ids":[1,2],"reasons":{"1":"reason","2":"reason"}}]'});
        saveSession();
        addMessage('typing');
        callClaude().then(function(rec) {
          removeTyping();
          if (rec) { history.push({role:'assistant', content:rec}); saveSession(); processReply(rec); }
        });
      });
      return;
    }
  }

  var ci = reply.indexOf('COMPARE:');
  if (ci > -1) {
    var parsed2 = null;
    try {
      var s2 = reply.slice(ci + 8);
      var d2 = 0, e2 = -1;
      for (var k = 0; k < s2.length; k++) {
        if (s2[k] === '{') d2++;
        else if (s2[k] === '}') { d2--; if (d2 === 0) { e2 = k; break; } }
      }
      if (e2 > -1) parsed2 = JSON.parse(s2.slice(0, e2 + 1));
    } catch(e) {}
    if (parsed2 && parsed2.ids && parsed2.ids.length >= 2) {
      var txtBefore2 = reply.slice(0, ci).trim();
      if (txtBefore2) addMessage('bot', txtBefore2);
      var pa = liveProducts.find(function(p){ return p.id === parseInt(parsed2.ids[0]) || p.id === parsed2.ids[0]; });
      var pb = liveProducts.find(function(p){ return p.id === parseInt(parsed2.ids[1]) || p.id === parsed2.ids[1]; });
      if (pa && pb) {
        function extractMaterial(p) {
          if (p.material) return p.material;
          if (p.additionalInfo) { var m = p.additionalInfo.match(/silicone|TPE|PVC|ABS|rubber|latex|glass|metal|steel/i); return m ? m[0] : null; }
          return null;
        }
        var fields = [
          { label: 'Price',             a: pa.price ? '$'+pa.price.toFixed(2) : null, b: pb.price ? '$'+pb.price.toFixed(2) : null },
          { label: 'Material',          a: extractMaterial(pa), b: extractMaterial(pb) },
          { label: 'Features',          a: pa.features, b: pb.features },
          { label: 'Insertable Length', a: pa.exactInsertableLength, b: pb.exactInsertableLength },
          { label: 'Width',             a: pa.exactWidth, b: pb.exactWidth },
          { label: 'Total Length',      a: pa.exactLength, b: pb.exactLength },
          { label: 'Colour',            a: pa.exactColor||pa.color, b: pb.exactColor||pb.color },
          { label: 'Texture',           a: pa.texture, b: pb.texture },
          { label: 'Stimulation',       a: pa.stimulation, b: pb.stimulation },
          { label: 'Power',             a: pa.power, b: pb.power },
          { label: 'Controller',        a: pa.controller, b: pb.controller },
          { label: 'Waterproof',        a: pa.waterproof, b: pb.waterproof },
          { label: 'Additional Info',   a: pa.additionalInfo, b: pb.additionalInfo },
        ];
        var tableHtml = '<div class="compare-table"><div class="compare-header"><span>' + escapeHtml(pa.name) + '</span><span>' + escapeHtml(pb.name) + '</span></div>';
        fields.forEach(function(row) {
          var empty = [null, undefined, '', 'null'];
          var aEmpty = empty.indexOf(row.a) > -1 || !row.a;
          var bEmpty = empty.indexOf(row.b) > -1 || !row.b;
          if (aEmpty && bEmpty) return;
          tableHtml += '<div class="compare-row"><span class="compare-label">' + row.label + '</span><span>' + (aEmpty ? '—' : escapeHtml(row.a)) + '</span><span>' + (bEmpty ? '—' : escapeHtml(row.b)) + '</span></div>';
        });
        tableHtml += '</div>';
        var wrap2 = document.getElementById('chat-messages');
        var dc = document.createElement('div'); dc.className = 'msg bot';
        dc.innerHTML = '<div class="msg-bubble">' + tableHtml + '</div>';
        var rowc = document.createElement('div'); rowc.className = 'feedback-row';
        rowc.innerHTML = '<button class="btn-restart" onclick="restartChat()">↺ Start over</button>';
        dc.appendChild(rowc);
        wrap2.appendChild(dc); scrollToBottom();
      }
      if (parsed2.summary) setTimeout(function() { addMessage('bot', parsed2.summary); }, 300);
      history.push({role:'assistant', content:reply}); saveSession(); return;
    }
  }

  var ri = reply.indexOf('RECOMMEND:');
  if (ri > -1) {
    var parsed = null;
    try {
      var s = reply.slice(ri + 10);
      var depth = 0, endIdx = -1;
      for (var i = 0; i < s.length; i++) {
        if (s[i] === '{') depth++;
        else if (s[i] === '}') { depth--; if (depth === 0) { endIdx = i; break; } }
      }
      if (endIdx > -1) parsed = JSON.parse(s.slice(0, endIdx + 1));
    } catch(e) { console.error('RECOMMEND parse:', e); }
    if (parsed && parsed.ids) {
      var txtBefore = reply.slice(0, ri).trim();
      if (txtBefore) addMessage('bot', txtBefore);
      var items = parsed.ids.map(function(id) {
        var numId = parseInt(id);
        var product = liveProducts.find(function(p) { return p.id === numId || p.id === id; });
        return { product: product, reason: (parsed.reasons && (parsed.reasons[id] || parsed.reasons[String(id)])) || '' };
      }).filter(function(x) { return x.product; });
      if (items.length) {
        addMessage('products', null, items);
        recordSession('Recommended: ' + items.map(function(i) { return i.product.name; }).join(', '));
        // Send analytics on every recommendation
        var conversation = history.map(function(m){return m.content;}).join(' ').toLowerCase();
        var identityMatch = conversation.match(/\b(woman|man|non-binary|prefer not to say)\b/);
        sendAnalytics({
          identity: identityMatch ? identityMatch[1] : '—',
          lookingFor: '—',
          budget: '—',
          collectionsSearched: liveProducts.length ? liveProducts[0].handle || '—' : '—',
          recommended: items.map(function(i){return i.product.name;}).join(', '),
          foundMatch: true,
          messageCount: history.length,
          sessionId: sessionId,
        });
        var afterRec = reply.slice(ri + 10);
        var d2 = 0, e2 = -1;
        for (var j = 0; j < afterRec.length; j++) {
          if (afterRec[j] === '{') d2++;
          else if (afterRec[j] === '}') { d2--; if (d2 === 0) { e2 = j; break; } }
        }
        if (e2 > -1) {
          var followUp = afterRec.slice(e2 + 1).trim();
          if (followUp) setTimeout(function() { addMessage('bot', followUp); }, 400);
        }
        history.push({role:'assistant', content:reply}); saveSession(); return;
      } else {
        console.warn('No products matched. ids:', parsed.ids);
      }
    }
  }

  addMessage('bot', reply);
  history.push({role:'assistant', content:reply}); saveSession();
}

async function fetchCollectionProducts(params) {
  try {
    var res = await fetch(WORKER + '/fetch-products', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(params)});
    var d = await res.json();
    return (d.products || []).map(function(p) { return Object.assign({}, p, {emoji:'🛍️'}); });
  } catch(e) { return []; }
}

async function callClaudeGreeting() {
  try {
    var res = await fetch(WORKER + '/chat', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({messages:[{role:'user',content:'Hi'}]})});
    var data = await res.json();
    var greeting = data.text || "Hi! I'm Molly 💗 How do you identify?\nCHIPS:[\"Woman\",\"Man\",\"Non-binary\",\"Prefer not to say\"]";
    history.push({role:'user', content:'Hi'});
    history.push({role:'assistant', content:greeting});
    saveSession();
    return greeting;
  } catch(e) {
    return "Hi! I'm Molly 💗 How do you identify?\nCHIPS:[\"Woman\",\"Man\",\"Non-binary\",\"Prefer not to say\"]";
  }
}

async function callClaude() {
  try {
    var msgs = history.length > 0 ? history : [{role:'user', content:'Hello'}];
    var body = {messages: msgs};
    if (liveProducts.length > 0) body.products = liveProducts;
    var res = await fetch(WORKER + '/chat', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
    var data = await res.json();
    if (data.error) return 'Sorry, I hit an error: ' + data.error;
    return data.text || "I'm having a little trouble connecting — please try again!";
  } catch(e) {
    return "Sorry, I had a connection hiccup! Please try again in a moment! 💗";
  }
}

function restartChat() {
  history = []; liveProducts = []; started = true;
  sessionStorage.removeItem('molly_session');
  document.getElementById('chat-messages').innerHTML = '';
  startConversation();
}
function handleKey(e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendUserMessage(); } }
function saveApiKey() {}
function showKeySetup() {}
